<template>
  <div class="special-detail">
    <div class="head-img ovh por" v-if="subjectInfo.web_head_img">
      <img :src="subjectInfo.web_head_img" alt="" class="w100 h100">
      <div class="subject poa l0 w100 lh1" v-if="subjectInfo.remark">
        <p class="fs16 subject-name">{{subjectInfo.name}}</p>
        <p class="subject-remark">{{subjectInfo.remark}}</p>
      </div>
    </div>
    <df-tag v-if="$route.params.id!=='undefined'" :list="tabList" :info="tagInfo" @change="changeTag" class="tags"></df-tag>
    <df-loading v-if="!courseList.length&&$route.params.id!=='undefined'" class="loading"></df-loading>
    <div class="course-box flex fww" v-if="courseList.length">
      <course-card v-for="(item,i) in courseList" :key="i" :item="item" image-width="226" image-height="259" width="226" imgKey="bgimg" class="course-box-item" :showProps="`name,${item.type === 3 ? 'price,buy_num':'hits'}`" @detail="changeJumpEvent(item)" flex='flex-col' is-custom-label>
      </course-card>
    </div>
		<offline v-if="$route.params.id==='undefined'" :is-no-data="!courseList.length" show class="no-data"></offline>
    <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
  </div>
</template>

<script>
import Mixins from '@/mixins/mixins';
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Specialdetail",
  mixins: [Mixins.MakeRoute(['id'], 'params')],
  data () {
    return {
      tabList: [
        { label: '分类', prop: 'tag_id', list: [] },
        {
          label: '排序', prop: 'order_by', list: [
            { name: '默认', id: '' },
            { name: '热门', id: 'hits_total desc' },
            { name: '最新', id: 'create_time desc' }]
        },
      ],
      tagInfo: {
        tag_id: '',
        order_by: ''
      },
      curr: 1,
      limits: 20,
      total: 0,
      courseList: [],
      subjectInfo: {},
      audioLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'allGrades', 'currPageCode', 'currAudio']),
    audio () {
      return this.currAudio ? this.GetAppAudio() : null;
    },
  },
  watch: {
    audio (val) {
      if (!this.audioLoading && val) {
        this.audioLoading = true;
        if (!this.currAudio.isPlay) {
          val.isAutoPlay = false;
        }
      }
    }
  },
  created () {
		// 当专题id为undefined时不请求接口及报错
		if(this.$route.params.id!=='undefined'){
			this.getCourseTag();
			this.getCourseList();
			this.getSubjectDetail();
		}
    
  },
  methods: {
    // 获取专题课程标签
    getCourseTag () {
      let params = {
        subject_id: this.id,
        ...this.Product
      };
      this.http.NEWGetCourseTag(params).then(res => {
        if (res.list.length) {
          res.list.unshift({ id: '', name: '全部' });
          this.tabList.find(e => e.prop === 'tag_id').list = res.list;
        }
      }).catch(this.$err);
    },
    // 获取专题详情
    getSubjectDetail () {
      this.http.getSubjectDetail({ subject_id: this.id }).then(res => {
        this.subjectInfo = res;
      }).catch(this.$err);
    },
    // 获取课程列表
    getCourseList () {
      let { curr, limits, userInfo, id, Product, tagInfo } = this;
      let params = {
        uid: userInfo.uid,
        subject_id: id,
        curr,
        limits,
        ...Product,
        ...tagInfo,
        is_web: 1
      };
      this.http.NEWGetSpecialCourse(params).then(res => {
        this.courseList = res.course_list.data;
        this.total = res.course_list.total;
      }).catch(this.$err);
    },
    // 点击跳转
    changeJumpEvent (item) {
      let url = `/home/${item.format_id === 1 ? 'video' : 'audio'}/details/${item.id}/${item.type}?subject_id=${this.id}`;
      this.OpenRouter(url);
    },
    changePage (value, prop) {
      this[prop] = value;
      this.getCourseList();
    },
    changeTag (item, prop) {
      this.tagInfo[prop] = item.id;
      this.getCourseList();
    }
  }
}
</script>

<style scoped lang="less">
.head-img {
  margin-top: 24px;
  height: 300px;
  border-radius: 8px;
  &:hover {
    .subject {
      bottom: 0;
    }
  }
}
.loading {
  padding: 100px 0;
  /deep/ .loading-tip {
    color: #333;
  }
}
.tags {
  margin-top: 24px;
}
.course-box {
  margin-left: -16px;
  /deep/ .detail-box {
    padding: 0;
    .course-price {
      padding: 12px 0;
    }
    .course-hits {
      padding-top: 16px;
    }
  }
  &-item {
    margin: 0 0 40px 16px;
  }
}
.subject {
  padding: 16px 24px;
  background-color: rgba(0, 15, 34, 0.6);
  border-radius: 0px 0px 8px 8px;
  bottom: -100%;
  transition: bottom 0.3s;
  &-name {
    color: #fff;
    padding-bottom: 11px;
  }
  &-remark {
    color: rgba(255, 255, 255, 0.7);
    line-height: 22px;
  }
}
</style>